import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ShopType } from 'types/shop.types';

import RatingStars from './Stars/Stars';

export type RatingFeedbacks = Pick<NonNullable<ShopType['feedbacks']>, 'avgRating' | 'total'> | null | undefined;

type Props = {
  feedbacks: RatingFeedbacks;
  onClick?: () => void;
  starSize?: number;
  direction?: 'row' | 'column';
};

const Rating = ({ feedbacks, onClick, starSize, direction = 'row' }: Props) => {
  const rating = feedbacks?.avgRating;
  const reviewsCount = feedbacks?.total;
  const { t } = useTranslation();

  return (
    <div className={classNames('rating', { 'rating-column': direction === 'column' })} onClick={onClick}>
      <RatingStars rating={rating} size={starSize} />
      {direction === 'row' ? (
        reviewsCount ? (
          <>
            <span className="rating-value">{rating}</span>
            <div className="rating-reviews-count">({reviewsCount})</div>
          </>
        ) : (
          <span className="rating-value-no-reviews">{t('components.feedback.no-reviews')}</span>
        )
      ) : reviewsCount ? (
        <div className="rating-reviews-count">
          {reviewsCount} {t('components.feedback.reviews-count', { count: reviewsCount })}
        </div>
      ) : (
        <span className="rating-value-no-reviews">{t('components.feedback.no-reviews')}</span>
      )}
    </div>
  );
};

export default Rating;
